const HowItWorksSection = () => {
  return (
    <section 
      className="py-16 md:py-24 bg-muted/30"
      aria-labelledby="how-it-works-title"
    >
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 
            id="how-it-works-title"
            className="mb-4 text-2xl font-bold md:text-3xl"
          >
            Como Funciona o Magnet Link
          </h2>
          <p className="mx-auto max-w-2xl text-muted-foreground">
            Em apenas 3 passos simples, você terá seu formulário inteligente funcionando
          </p>
        </div>
        <div className="mx-auto grid max-w-4xl gap-8 md:grid-cols-3">
          <article className="text-center">
            <div 
              className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary text-2xl font-bold text-primary-foreground"
              aria-hidden="true"
            >
              1
            </div>
            <h3 className="mb-2 text-lg font-semibold">Crie o Formulário</h3>
            <p className="text-sm text-muted-foreground">
              Configure os campos iniciais e as instruções para a IA gerar perguntas personalizadas
            </p>
          </article>
          <article className="text-center">
            <div 
              className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary text-2xl font-bold text-primary-foreground"
              aria-hidden="true"
            >
              2
            </div>
            <h3 className="mb-2 text-lg font-semibold">Compartilhe o Link</h3>
            <p className="text-sm text-muted-foreground">
              Envie o link único para seus leads nas redes sociais, email ou site
            </p>
          </article>
          <article className="text-center">
            <div 
              className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary text-2xl font-bold text-primary-foreground"
              aria-hidden="true"
            >
              3
            </div>
            <h3 className="mb-2 text-lg font-semibold">Colete Respostas</h3>
            <p className="text-sm text-muted-foreground">
              A IA faz perguntas personalizadas e gera o PDF automaticamente para o lead
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
